import BpkImage from '@skyscanner/backpack-web/bpk-component-image';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import withErrorBoundary from '../ErrorBoundary';

import ExpandingCard from './ExpandingCard';

import type { AboutAirlineProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/AboutAirlineProps';

import STYLES from './AboutAirline.module.scss';

const AboutAirline = ({
  aboutAirlineBlurb,
  airlineLogo,
  headerH2,
  panels,
}: AboutAirlineProps) => (
  <div className={STYLES.AboutAirline}>
    <BpkText
      className={STYLES.AboutAirline__header}
      tagName="h2"
      textStyle={TEXT_STYLES.heading3}
    >
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: headerH2 }} />
    </BpkText>
    {airlineLogo && (
      <BpkImage
        className={STYLES.AboutAirline__logo}
        altText=""
        aspectRatio={204 / 100}
        src={airlineLogo}
      />
    )}
    <span
      className={STYLES.AboutAirline__blurb}
      /* eslint-disable-next-line react/no-danger */
      dangerouslySetInnerHTML={{ __html: aboutAirlineBlurb }}
    />
    <div>
      {panels.map((panel) => (
        <ExpandingCard
          key={panel.header}
          header={panel.header}
          text={panel.text}
        />
      ))}
    </div>
  </div>
);

const AboutAirlineWithErrorBoundary = withErrorBoundary(
  AboutAirline,
  'about-airline-component',
);
export default AboutAirlineWithErrorBoundary;
